import React from 'react'
import { FaSearch } from 'react-icons/fa'
import { InstantResult } from './instant_result'

export const InstantSearch = () => {
    const [open, setOpen] = React.useState(false)
    const [query, setQuery] = React.useState('')

    return ( 
        <div className="searcher">
            <div className="search" onClick={()=>setOpen(!open)}>
                <FaSearch />
                <input 
                placeholder="Search" 
                value={query}
                onChange={e=>setQuery(e.target.value)} />
            </div>
           { open===true && <InstantResult q={query} /> }
        </div>
    )
}
 